export var TypedResolverType;
(function (TypedResolverType) {
    TypedResolverType["BOOLEAN"] = "resolver::boolean";
    TypedResolverType["DATE"] = "resolver::date";
    TypedResolverType["DECIMAL"] = "resolver::decimal";
    TypedResolverType["INTEGER"] = "resolver::integer";
    TypedResolverType["STRING"] = "resolver::string";
    TypedResolverType["ZONED_DATETIME"] = "resolver::zoned_datetime";
})(TypedResolverType || (TypedResolverType = {}));
